/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `done` - Requirement met
 * * `partial` - Part of the work reached us
 * * `missing` - No record reached us
 * * `skipped` - Skipped visit
 * * `open` - Period still running
 */
export type OutcomeEnum = typeof OutcomeEnum[keyof typeof OutcomeEnum];


export const OutcomeEnum = {
  done: 'done',
  partial: 'partial',
  missing: 'missing',
  skipped: 'skipped',
  open: 'open',
} as const;
